<div class="main_div">
  <div class="body_title">Donor Management</div>
  <div class="main_body">
    <div class="main_body_title">
      <div class="body_title">Overview</div>
      <div (click)="lapsedPopup()" class="body_title_lapsed cursor">
        <div class="body_title lapsed">Lapsed Setting</div>
        <div class="lapsed_icon">
          <img
            src="./assets/images/icon/lapsed_icon.svg"
            alt="lapsed_icon"
            loading="lazy"
          />
        </div>
      </div>
    </div>
    <div class="overview_carts">
      <div *ngFor="let carts of overviewCarts" class="carts">
        <div class="carts_img">
          <img [src]="carts.carts_icon" alt="" />
        </div>
        <div class="carts_title">
          {{ carts.carts_name }}
        </div>
        <div class="total_amount">
          <span style="color: #0054a6" *ngIf="carts.isAmount">৳ </span>
          {{
            carts.id === "top_campaign_title"
              ? carts.calculated_data
              : (carts.calculated_data | number : "1.0-2")
          }}
        </div>
      </div>
    </div>
    <div class="main_body_title">
      <div class="body_title">
        List of all donors who have supported your campaigns.
      </div>
      <div
        class="d-flex align-items-center gap-2 cursor"
        (click)="exportGrid()"
      >
        <img
          width="22px"
          src="./assets/images/icon/download-icon.svg"
          alt="Download"
          loading="lazy"
        />
        <div class="body_title lapsed">Export List</div>
      </div>
    </div>
    <div class="grid_component">
      <div class="date_picker_row">
        <div class="date_picker">
          <div class="date_picker_title">By Date Range:</div>
          <dx-date-range-box
            class="time_line"
            [startDate]="startDate"
            [endDate]="endDate"
            labelMode="floating"
            [min]="oneYearAgo"
            [max]="today"
            displayFormat="dd MMM, yyyy"
            (onValueChanged)="updateDateRange($event)"
          ></dx-date-range-box>
        </div>
      </div>
      <div class="top_donor_div pr-0">
        <div class="donor_div">
          <dx-data-grid
            #donorList
            class="chart_div data_grid"
            [dataSource]="donorsList"
            [showBorders]="false"
            [showColumnLines]="false"
            [showRowLines]="false"
            [allowColumnResizing]="true"
            columnResizingMode="widget"
            [focusedRowEnabled]="false"
            [rowAlternationEnabled]="false"
            rowTemplate="rowTemplateName"
            [wordWrapEnabled]="true"
            [columnAutoWidth]="true"
          >
            <dxo-paging [pageSize]="7"></dxo-paging>
            <dxo-pager
              [visible]="true"
              [showPageSizeSelector]="false"
              allowedPageSizes="10"
              [showInfo]="true"
            >
            </dxo-pager>
            <dxi-column
              caption="Donor Name"
              dataField="donor_name"
              [allowExporting]="true"
            ></dxi-column>
            <dxi-column
              caption="Email"
              dataField="donor_email"
              [allowExporting]="true"
            >
            </dxi-column>
            <dxi-column
              caption="Total Donation Amount"
              dataField="total_amount"
              alignment="start"
              [allowExporting]="true"
            >
            </dxi-column>
            <dxi-column
              caption="Campaigns Participated"
              dataField="campaigns_participate"
              alignment="start"
              [allowExporting]="true"
            >
            </dxi-column>

            <tbody class="dx-row" *dxTemplate="let row of 'rowTemplateName'">
              <tr class="custom-row">
                <td>
                  <div
                    class="name_mobile_img"
                    (click)="navigateToProfile(row?.data)"
                  >
                    <div class="img">
                      <img
                        loading="lazy"
                        [src]="
                          getUrl(row?.data?.profile_img) ||
                          './assets/images/round_profile.png'
                        "
                        alt="PROFILE"
                      />
                    </div>
                    <div class="name_mobile">
                      <div class="donor_name cursor">
                        {{ row?.data?.donor_name }}
                      </div>
                    </div>
                  </div>
                </td>

                <td class="campaign_name">
                  <div class="transfer">
                    {{ row?.data?.donor_email }}
                  </div>
                </td>

                <td>
                  <div class="amount_div">
                    ৳ {{ row?.data?.total_amount | number }}
                  </div>
                </td>

                <td>
                  <div class="combine">
                    <div
                      class="employee_rank multiple_icon"
                      style="margin-right: 8px"
                    >
                      <img
                        loading="lazy"
                        src="./assets/images/icon/person-logo-icon.svg"
                        alt="rank"
                      />
                    </div>
                    <span class="normal_data" style="color: #0054a6">
                      ({{ (row.data?.supported_campaigns | number) || 0 }})
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>

<dx-popup
  [width]="'50vw'"
  [height]="'50vh'"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="lapsedDonorPopup"
  [showTitle]="false"
>
  <div class="root">
    <div
      class="cross_button_div_"
      style="margin-right: 20px; text-align: right; width: 100%"
    >
      <button class="cross_button" (click)="closeCreateEmailPopup()">
        <img
          src="../../../../../assets/images/icon/x-circle.svg"
          alt="cross"
          loading="lazy"
          title="close"
        />
      </button>
    </div>

    <div class="body">
      <div class="email_title">Lapsed Donor Setting</div>
      <div style="width: 100%">
        <label class="value">Donation frequency </label>
        <div class="text_box_button">
          <dx-text-box
            class="input_field text_box"
            [placeholder]="'Donor will be Lapsed if they don’t donate in'"
            [showClearButton]="true"
          >
            <dx-validator validationGroup="validationGrp">
              <dxi-validation-rule
                type="required"
                message="Subject is Required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
          <dx-select-box
            class="input_field select_box"
            [dataSource]="['6 Months', '7 Months']"
            [showClearButton]="true"
            [placeholder]="'Select Time'"
          >
            <dx-validator validationGroup="validationGrp">
              <dxi-validation-rule type="required" message="Area is required.">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
      </div>
    </div>

    <div class="buttons">
      <dx-button class="blue-button-md">Save Changes</dx-button>
    </div>
  </div>
</dx-popup>

<app-receipts></app-receipts>
